/**
 * Renders an image from an authenticated API endpoint by fetching it as a blob
 * (so the Bearer token interceptor applies) and using an object URL.
 */
import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function AuthImage({ src, alt, className, onClick }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let revoked = false;
    let objUrl = null;
    setErr(false);
    setUrl(null);
    // `src` is an /api-relative path like /api/safety/observations/{id}/photos/{pid}
    const path = src.startsWith('/api') ? src.slice(4) : src;
    api.get(path, { responseType: 'blob' })
      .then((r) => {
        if (revoked) return;
        objUrl = URL.createObjectURL(r.data);
        setUrl(objUrl);
      })
      .catch(() => setErr(true));
    return () => { revoked = true; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [src]);

  if (err) return <div className={`${className} bg-slate-100 flex items-center justify-center text-[10px] text-slate-400`}>image unavailable</div>;
  if (!url) return <div className={`${className} bg-slate-100 animate-pulse`} />;
  return <img src={url} alt={alt} className={className} onClick={onClick} />;
}
